// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name, other, w = 22, h = 22) =>
  other ? (
    <img
      alt="navIcon"
      src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.${other}`}
      style={{ width: w, height: h }}
    />
  ) : (
    <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  );

const Customer = [ 
  {
    title: 'Manage Bookings',
    path: '/dashboard/manage/booking',
    icon: icon('company', 'png'),
    ShortName: 'ManageBooking',
  },
  {
    title: 'Complaint Review',
    path: '/dashboard/manage/customer_complaint_review',
    icon: icon('company', 'png'),
    ShortName: 'CustomerComplaintReview',
  },
];

export default Customer;
